module.exports = "\n<app-user-regi-biller></app-user-regi-biller>\n<app-services></app-services>\n<app-gen-info></app-gen-info>\n<app-new-payment-ui></app-new-payment-ui>\n<!-- <app-gen-ads></app-gen-ads> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main